import React from 'react';
import { Redirect, Link, withRouter, useHistory } from 'react-router-dom';
import { Button, ListGroup, ListGroupItem, Container, Col, Row } from 'reactstrap';

import PlaybackEngine from '../api/PlaybackEngine'

import ListItem from '../components/ListItem';

import { Input } from 'reactstrap';
import ShareBtn from '../components/ShareBtn';

import {encode, decode} from '../utils/ListEncoder'


export default class List extends React.Component {


  constructor(props) {

    super(props);

    this.state = {
      error: '',
      choosenItems: [],
      readyToPlay: false,
      playing: false,
      checked: []
    };


    this.navContent = this.props.content;

    this.soundAdded = this.soundAdded.bind(this);
    this.soundRemoved = this.soundRemoved.bind(this);

    this.onLoading = this.onLoading.bind(this);
    this.onReady = this.onReady.bind(this);
    this.onPlaying = this.onPlaying.bind(this);
    this.onStopped = this.onStopped.bind(this);

    this.addSelectionToNav = this.addSelectionToNav.bind(this);

    this.params = new URLSearchParams(window.location.search);
    this.items = this.props.dataListe
    this.epicerie = this.props.dataListe

    this.engine = new PlaybackEngine(this.props.dataListe, {
      onReady : this.onReady,
      onLoading : this.onLoading,
      onPlaying : this.onPlaying,
      onStopped : this.onStopped
    });

    while(this.props.dataListe.length > this.state.checked.length){
      this.state.checked.push(0)
    }

    let query = this.navContent.location.search.substring(1)
    let items = decode(query);

    items.forEach((itemId, i) => {
        let indexPos = this.items.findIndex(x => x.id === this.items[itemId-1].id);
        if(indexPos >= 0){
          this.soundAdded(indexPos,this.items[itemId-1])
          this.checked(indexPos,indexPos )
        }
    });

    //If we had an error decoding
    if(items.length == 0){
      this.navContent.push('?')
    }
  }

  componentDidMount() {

  }

  onLoading(){
    this.setState({readyToPlay : false});
  }
  onReady(){
    this.setState({readyToPlay : true});
  }
  onPlaying(){
    this.setState({readyToPlay : false});
  }
  onStopped(){
      //readyToPlay should reset to true from the ready callback triggered by the sound reload
  }

  addSelectionToNav() {
    let idList = this.state.choosenItems.map((obj) => {return obj.item.id})

    let b64URL = encode(idList);
    b64URL = '?' + b64URL

    this.navContent.push(b64URL)

  }

  soundAdded(index, item) {
    this.engine.stop()

    this.state.choosenItems.push({ index, item, loaded: false });
    let list = this.state.choosenItems.map((item) => {
      return item.index;
    })

    this.engine.setList(list);
console.log(list)
    this.setState({ choosenItems: this.state.choosenItems }, () => {

      this.addSelectionToNav();

    });
  }




  checked(index, item) {
    this.state.checked.splice(index, 1, true);
    this.setState({ checked: this.state.checked });

  }

  soundRemoved(index, item) {
    this.engine.stop();

    let choosenItems = this.state.choosenItems.filter(item => item.index != index);

    let list = choosenItems.map((item) => {
      return item.index;
    })

    this.engine.setList(list);

    this.setState({ choosenItems }, () => {
      this.addSelectionToNav();

    })

  }

  render() {


    const listItems = this.items.map((item, index) => {

      return <ListItem
        key={index}
        index={index}
        item={item}
        onAdded={this.soundAdded}
        onRemove={this.soundRemoved}
        status={this.state.checked[index]} />
    })




    const choosenItems = this.state.choosenItems.map((choosenItem, index) => {

      return <ListGroupItem key={index}  > {choosenItem.item.name}</ListGroupItem>
    });


    let controlButton;

    if (this.state.playing) {
      controlButton = <Button color="danger" onClick={this.stopAll}> Stop </Button>;
    } else {
      controlButton = <Button color={this.state.readyToPlay ? "success" : "danger"} disabled={!this.state.readyToPlay} onClick={this.engine.play}> Play </Button>;
    }

    return (
      <React.Fragment>

        <Row>

          <Col md={{ size: 3, offset: 3 }}>


            <h2 className="mb-5" >Aliments</h2>
            <ListGroup>
              {listItems}
            </ListGroup>

          </Col>
          <Col md={{ size: 3, offset: 0 }}>
            <h2 className="mb-5">Épicerie</h2>
            <ListGroup className="mb-3">
              {choosenItems}
            </ListGroup>
            {controlButton}
            <h4>Mix</h4>
            <Input type="number" onChange={this.handleMixChange} step='0.1' name="state" id="exampleState" />
            <h4>Time</h4>
            <Input type="number" onChange={this.handleTimeChange} step='0.1' name="state" id="exampleState" />
            <h4>Decay</h4>
            <Input type="number" onChange={this.handleDecayChange} step='0.1' name="state" id="exampleState" />








          </Col>

        </Row>

      <ShareBtn text="Partager ma liste"></ShareBtn>
      </React.Fragment>
    );
  }
}
